import React, {Component} from 'react';
import classnames from 'classnames';
import {getPriority} from "../models";


const WorkflowTaskPriority = ({ priority }) => {
  const priorityValue = getPriority(priority)
  return (
    <span className={classnames([
     `text-${priorityValue.colorName}`, 'task-priority'
    ])}>
      {priorityValue.name}
    </span>
  )
};

export default WorkflowTaskPriority;
